<template>
  <div v-if="currentDevice">
    <v-expansion-panels class="elevation-0" accordion v-model="panel">
      <v-expansion-panel  v-bind:key="peripheral.uuid" v-for="peripheral in currentDevice.peripherals">
        <v-expansion-panel-header class="px-2 pb-0">
          <div class="d-flex align-start">
            <v-icon class="mr-2 text--secondary" size="18">{{ icons[peripheral['device_type_name']] }}</v-icon>
            <div class="d-flex flex-row align-center">
              <h3 class="text-primary subtitle-2 mb-0 mr-2">{{ peripheral.name }}</h3>
              <span v-if="!peripheral.enabled" class="subtitle-2 mb-0" style="color: #FF5252"><span class="text-primary subtitle-2 mb-0">|</span> Disabled</span>
              <span v-if="isPeripheralFaulty(peripheral)" class="subtitle-2 mb-0 ml-1" style="color: #FF5252"><span class="text-primary subtitle-2 mb-0">|</span> Faulty</span>
            </div>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row v-if="peripheral.device_type_name === 'Bill Acceptor' || peripheral.device_type_name === 'Coin Acceptor' || peripheral.device_type_name === 'Card Reader' || peripheral.device_type_name === 'Camera' || peripheral.device_type_name === 'Time Attendance Lock' || peripheral.device_type_name === 'Signature Pad'" class="mt-0 pt-0 d-flex justify-space-between align-center text--secondary">
            <span>Enabled</span>
            <v-switch :input-value="peripheral.enabled" color="primary" @change="togglePeripheralDevice(peripheral)">
            </v-switch>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import {mapActions} from "vuex";
import {mdiCash, mdiHandCoin, mdiNfc, mdiPowerPlug, mdiPrinter, mdiScanner, mdiWebcam, mdiDoorClosedLock, mdiDrawPen } from "@mdi/js";
import peripheralStatus from "../../../../mixins/peripheralStatus";

export default {
  props: ['device'],
  name: "PeripheralsMisc",
  mixins: [peripheralStatus],
  methods: {
    ...mapActions({
      togglePeripheralStatus: 'devices/togglePeripheralStatus',
      setActivePeripheral: 'devices/setActivePeripheral',
    }),
    togglePeripheralDevice(peripheral) {
      let type = Object.keys(this.categories).find(key => this.categories[key].indexOf(peripheral.device_type_name) !== -1);
      this.togglePeripheralStatus({
        device_uuid: this.device.uuid,
        type: type,
        peripheral_uuid: peripheral.uuid,
        status: !peripheral.enabled
      });
    },
  

  },
  data: () => ({
    panel: null,
    currentDevice: {},
    icons: {
      'Coin Acceptor':  mdiHandCoin,
      'Bill Acceptor': mdiCash,
      'Door Switch': mdiPowerPlug,
      'POS Printer': mdiPrinter,
      'Card Reader': mdiNfc,
      'Document Scanner': mdiScanner,
      'Camera': mdiWebcam, 
      'Time Attendance Lock': mdiDoorClosedLock,
      'Signature Pad': mdiDrawPen

    },
    categories: {
      'money-acceptor': ['Coin Acceptor', 'Bill Acceptor'],
      'card-reader':['Card Reader'],
      'camera': ['Camera'],
      'time-attendance-lock': ['Time Attendance Lock'],
      'signature-pad': ['Signature Pad']    
    }
  }),
  watch: {
    panel: {
      handler(val) {
        this.setActivePeripheral({
          index: val,
          type: 'misc',
          device: this.device.uuid
        });
      }
    },
    device: {
      immediate: true,
      handler(val) {
        this.currentDevice = val;
      },
      deep: true
    }
  },
}
</script>

<style scoped>
::v-deep .v-expansion-panel-header--active {
  background-color: var(--v-background-base) !important; 
}

::v-deep .v-expansion-panel-content__wrap {
  background-color: var(--v-background-base)  !important;
  border-radius: 4px;
}
</style>